import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-6" }
const _hoisted_2 = { class: "flex overflow-x-auto" }
const _hoisted_3 = ["data"]
const _hoisted_4 = { class: "font-bold text-left border-b-2 border-black divide-x-2 divide-gray-400" }
const _hoisted_5 = {
  scope: "col",
  class: "w-64 px-2 py-2 capitalize"
}
const _hoisted_6 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_7 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_8 = { class: "px-2 py-3 capitalize" }
const _hoisted_9 = { class: "px-2 py-2 capitalize whitespace-nowrap" }
const _hoisted_10 = { class: "px-2 py-2 divide-x divide-gray-400 whitespace-nowrap" }
const _hoisted_11 = ["href"]

import { ref } from "vue";
import { storeToRefs } from "pinia";

import TitleHeader from "../components/TitleHeader.vue";
import TimezoneSpan from "../components/TimezoneSpan.vue";

import api from "@/api/api";
import { Booking } from "@/types";
import { useUserStore } from "@/store";
import { getCertificateUrl, shouldShowCertificateUrl } from "@/utils/certificates";


export default /*#__PURE__*/_defineComponent({
  __name: 'CertificatesList',
  async setup(__props) {

let __temp: any, __restore: any

const { user } = storeToRefs(useUserStore());

const bookings = ref([] as Booking[]);

/** Lists bookings where user is user_id on bookings */
bookings.value = ((
  ([__temp,__restore] = _withAsyncContext(() => api.users.getBookingsByUser(user.value.id))),
  __temp = await __temp,
  __restore(),
  __temp
)).data.bookings;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TitleHeader, {
      title: _ctx.$t('completion-record-certificates'),
      class: "mt-6"
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", {
          data: bookings.value,
          class: "w-full table-auto mt-2.5"
        }, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_4, [
              _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t("course")), 1),
              _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t("date-completed")), 1),
              _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t("actions")), 1)
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bookings.value.slice(0, 3), (booking) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "border-b border-gray-400 divide-x-2 divide-gray-400 odd:bg-gray-200",
                key: booking.id
              }, [
                _createElementVNode("td", _hoisted_8, _toDisplayString(booking.event!.name), 1),
                _createElementVNode("td", _hoisted_9, [
                  _createVNode(TimezoneSpan, {
                    date: booking.completed_at,
                    locale: "en-GB",
                    "date-style": "short",
                    "time-style": "long"
                  }, null, 8, ["date"])
                ]),
                _createElementVNode("td", _hoisted_10, [
                  (_unref(shouldShowCertificateUrl)(booking))
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: _unref(getCertificateUrl)(booking, booking.user),
                        class: "px-2 text-blue"
                      }, _toDisplayString(_ctx.$t("view_certificate_pdf")), 9, _hoisted_11))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128))
          ])
        ], 8, _hoisted_3)
      ])
    ])
  ], 64))
}
}

})